import httpService from '../httpService';
import { GetAllScoreCardsResponse, ScoreCard, ScoreCardCreateInfo, ScoreCardUpdateInfo } from '../../models/scoreCard.model';
import { store } from '../../redux/store';
import { RootState } from '../../redux/reducers';

export async function getAllScoreCards(): Promise<GetAllScoreCardsResponse> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .get<GetAllScoreCardsResponse>(`/networks/communities/${selectedCommunity}/score-cards`)
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
}

export async function createScoreCard(
  data: ScoreCardCreateInfo,
): Promise<ScoreCard> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .post<ScoreCard>(`/networks/communities/${selectedCommunity}/score-cards/`, data)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function deleteScoreCard(scoreCardId: number): Promise<ScoreCard> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .delete<ScoreCard>(`/networks/communities/${selectedCommunity}/score-cards/${scoreCardId}`)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function updateScoreCardScore(
  scoreCardId: number,
  memberId: number,
  newScore: number,
): Promise<ScoreCard> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  const body = {
    scores: [{ memberId, score: newScore }],
  };

  return httpService
    .put<ScoreCard>(`/networks/communities/${selectedCommunity}/score-cards/${scoreCardId}/scores`, body)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function updateScoreCardScores(
  scoreCardId: number,
  scores: { memberId: number; score: number }[],
): Promise<void> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .put<void>(`/networks/communities/${selectedCommunity}/score-cards/${scoreCardId}/scores`, { scores })
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function updateScoreCard(
  scoreCardId: number,
  data: ScoreCardUpdateInfo,
): Promise<ScoreCard> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .put<ScoreCard>(`/networks/communities/${selectedCommunity}/score-cards/${scoreCardId}`, data)
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function addMemberToScoreCard(
  scoreCardId: number,
  connectionId: number,
): Promise<ScoreCard> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .post<ScoreCard>(
      `/networks/communities/${selectedCommunity}/score-cards/${scoreCardId}/members`,
      { connectionId },
    )
    .then((res) => res.data)
    .catch((err) => {
      if (err.response.status === 401) {
        throw new Error('UNAUTHORIZED');
      }
      throw err;
    });
}

export async function removeMemberFromScoreCard(
  scoreCardId: number,
  connectionId: number,
): Promise<ScoreCard> {
  const { selectedCommunity } = (store.getState() as RootState).application;

  return httpService
    .delete<ScoreCard>(
      `/score-cards/${selectedCommunity}/${scoreCardId}/connections/${connectionId}`,
    )
    .then((res) => res.data);
}
